import { render, staticRenderFns } from "./fifthPage.vue?vue&type=template&id=69587d55&"
import script from "./fifthPage.vue?vue&type=script&lang=js&"
export * from "./fifthPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports